import { Component, OnInit } from '@angular/core';
@Component({ templateUrl: './content.component.html' })
export class ScheduleSupportComponent implements OnInit {

  ngOnInit(): void {

  }
}
